<template>
	<div>
		<hal-banner-ambiente ref="halBannerAmbiente" produto-id="9"></hal-banner-ambiente>
		<div class="ata">
			<loading></loading>
			<hal-informativos ref="halInformativos" produto-id="9"></hal-informativos>
			<hal-notificacoes ref="halMenuNotificacoes" align-items="left"></hal-notificacoes>
			<hal-menu-produtos ref="halMenuProdutos"></hal-menu-produtos>
			<az-template-default id="az-template-default">
				<router-view></router-view>
				<chat></chat>
			</az-template-default>
		</div>
	</div>
</template>

<script>
import { actionTypes, getterTypes, routesNames } from '@/core/constants'
import { mapGetters } from 'vuex'

import axios from 'axios'

export default {
	name: 'root-page',
	computed: {
		...mapGetters({
			orgaoLogado: getterTypes.COMUM.GET_ORGAO_LOGADO,
		}),
	},
	created() {
		this.configRequestsHalWebComponents()
	},
	mounted() {
		this.setThemeColor()
		window.addEventListener('focus', this.atualizarSessao)
		this.incluirHalInformativosNoHeader
		this.incluirHalMenuNotificacaoNoHeader()
		this.incluirHalMenuProdutoNoHeader()
		const halBannerAmbiente = this.$refs.halBannerAmbiente
		const applicationWrap = document.querySelector('.v-application--wrap')
		const azToolbar = document.querySelector('header.toolbar')
		const azAside = document.querySelector('nav.az-aside')
		const mainContent = document.querySelector('main.v-main')

		applicationWrap.insertBefore(halBannerAmbiente, azToolbar)

		customElements.whenDefined('hal-banner-ambiente').then(() => {
			setTimeout(() => {
				const altura = halBannerAmbiente.shadowRoot.querySelector('div').offsetHeight

				azAside.querySelector('.az-aside').style['margin-top'] = `${altura}px`
				azToolbar.style['margin-top'] = `${altura}px`
				mainContent.style['margin-top'] = `${altura}px`
			}, 500)
		})
	},
	beforeDestroy() {
		window.removeEventListener('focus', this.atualizarSessao)
	},
	methods: {
		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms))
		},
		configRequestsHalWebComponents() {
			window.hal = {
				http: {
					get: async ({ url }) => axios.get(url),
					post: async ({ url, data, config }) => axios.post(url, data, config),
					put: async ({ url, data, config }) => axios.put(url, data, config),
					delete: async ({ url }) => axios.delete(url),
				},
			}
		},
		async atualizarSessao() {
			await this.sleep(500)
			try {
				await this.executarSemLoading(() =>
					this.$store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, this.orgaoLogado),
				)
			} catch (error) {
				await this.executarSemLoading(() => this.$store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, 0))
				await this.$router.push({ name: routesNames.INICIO })
			}
		},
		incluirHalInformativosNoHeader() {
			const halInformativos = this.$refs.halInformativos
			const azToolbar = document.querySelector('.v-toolbar__content')
			const azAvatar = document.querySelector('.az-avatar')

			azToolbar.insertBefore(halInformativos, azAvatar)
		},
		incluirHalMenuNotificacaoNoHeader() {
			const halMenuNotificacoes = this.$refs.halMenuNotificacoes
			const azToolbar = document.querySelector('.v-toolbar__content')
			const azAvatar = document.querySelector('.az-avatar')

			azToolbar.insertBefore(halMenuNotificacoes, azAvatar)
		},
		incluirHalMenuProdutoNoHeader() {
			const halMenuProdutos = this.$refs.halMenuProdutos
			const azToolbar = document.querySelector('.v-toolbar__content')
			const azAvatar = document.querySelector('.az-avatar')

			azToolbar.insertBefore(halMenuProdutos, azAvatar)
		},
		setThemeColor() {
			const [corPrimaria, corSecundaria] = [
				this.$store.state.parametrosSistema.corPrimaria,
				this.$store.state.parametrosSistema.corSecundaria,
			]

			if (corPrimaria && this.validarParametroCorSistema(corPrimaria)) {
				this.$vuetify.theme.themes.light.primary = this.$store.state.parametrosSistema.corPrimaria
			} else {
				this.mostrarNotificacaoWarning('A cor primária configurada não segue o formato de cores do sistema.')
			}

			if (corSecundaria && this.validarParametroCorSistema(corSecundaria)) {
				this.$vuetify.theme.themes.light.secondary = this.$store.state.parametrosSistema.corSecundaria
			} else {
				this.mostrarNotificacaoWarning('A cor secundária configurada não segue o formato de cores do sistema.')
			}
		},
		validarParametroCorSistema(parametroCorSistema) {
			const hexColorRegex = /^#[0-9a-fA-F]{6}$/

			return hexColorRegex.test(parametroCorSistema)
		},
	},
}
</script>

<style lang="stylus">
getSizeRem(size)
	unit((size / 16), rem)

html {
	overflow auto
	font 'Open Sans', Arial, 'Sans-Serif'
	box-sizing border-box
}

.btn-icon__editar-item-az-money
	top 8px !important
	font-size 18px !important
	position relative !important
	height 20px !important

.arp-highlight-busca
	color var(--v-primary-base) !important

.arp-col
	flex-basis 0 !important
	flex-grow 0 !important

.arp-iframe
	width 100%
	height 100%
	border 0

.arp-text-color
	color var(--v-grey-darken1)

.botao-tamanho-arp .v-btn
	width (116 / 16) rem !important

.ata
	.az-container
		margin getSizeRem(20)

	.az-container.listagem
		padding getSizeRem(8) getSizeRem(24)

	.pr-text-color
		color var(--v-secondary-base)

	.pr-titulo
		color var(--v-grey-darken1)
		padding 12px

	.az-template-default

		.az-logo
			display flex
			justify-content center
			align-items center
			padding-top 16px
			.main
				width 85%
			a
				max-width 150px

		.active-menu
			font-weight: 700 !important

		.az-menu

			.v-list-item__title
				white-space wrap !important
				padding-right 10px !important
				font-weight 700
				color rgba(255, 255, 255, 0.8) !important

		.container
			padding 1px

		.mobile_menu
			display none

		.toolbar
			-webkit-box-shadow 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important
			box-shadow 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important
			background-color #fff !important

	.arp-selecao-itens-pedido
		.arp-selecao-itens-pedido-cabecalho
			margin-top getSizeRem(16)

			.arp-selecao-itens-pedido-cabecalho-titulo
				color: var(--v-primary-base)
				font-size: getSizeRem(9)
				margin-top: getSizeRem(16)

		.arp-selecao-itens-pedido__listagem, .arp-selecao-itens-pedido-cabecalho, .arp-selecao-itens-pedido__rodape
			padding-left getSizeRem(23)
			padding-right getSizeRem(23)

		.arp-selecao-itens-pedido__rodape
			padding-bottom getSizeRem(23)
			margin-top getSizeRem(13)

	//Vuetify - override

	.aberto
		.v-expansion-panel-content__wrap
			padding 0 getSizeRem(17)

	.theme--dark.v-tabs
		background-color var(--v-primary-base)
		padding-top 10px
		border-radius 5px 5px 0 0

	.theme--dark.v-tabs > .v-tabs-bar
		background-color var(--v-primary-base)


	.v-tabs--vertical > .v-tabs-bar .v-tab
		height getSizeRem(39)

	.v-tab
		text-transform none
		font-size getSizeRem(14)
		font-weight 700
		letter-spacing normal
		line-height getSizeRem(39)

	.theme--dark .v-tab
		background var(--v-primary-base)
		color var(--v-accent-lighten5)
		border-radius 5px 5px 0 0
		font-weight normal
		margin 0 10px

	.theme--dark .tab-ativa.v-tab
		background var(--v-accent-lighten5)
		color var(--v-primary-base)

	.v-btn
		letter-spacing normal
		padding .5rem 0

	.arp-listview td:hover
		cursor pointer !important

	.arp-listview-stripped
		.v-data-table > .v-data-table__wrapper > table > tbody > tr > td
			padding: 0.7rem 0.8rem !important;

		.theme--light.v-data-table > .v-data-table__wrapper > table > tbody
			> tr:first-child > td:not(.v-data-table__mobile-row)
				border-top: thin solid rgba(0, 0, 0, .12)
				border-bottom: thin solid rgba(0, 0, 0, .18)

			> tr > td:not(.v-data-table__mobile-row)
				border-bottom: thin solid rgba(0, 0, 0, .18)

			> tr > td:first-child:not(.v-data-table__mobile-row)
				border-left: thin solid rgba(0, 0, 0, .12)

			> tr > td:last-child:not(.v-data-table__mobile-row)
				border-right: thin solid rgba(0, 0, 0, .12)

	.arp-no-data-table-row
		margin: 60px 0 !important

		i.v-icon.arp-icon-no-data
			opacity 80%

		.arp-no-data-table-mensagem
			width: 35%
			text-align: center

	.az-search .simple-search .input-search
		background-color white !important

	.v-data-table
		font-size getSizeRem(14)

	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th
		padding 0 .5rem
		font-size inherit

	.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
	.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
	.v-data-table > .v-data-table__wrapper > table > thead > tr > th
		font-size: inherit

		&__erro-inicializacao
			width 100%
			padding 0
			text-align center
			color #555
			height 90vh
			display flex
			justify-content center
			align-items center

			i
				font-size 36px

			p
				font-size 20px
				margin 10px 0 0
				font-weight 600

	.container-desentranhamento
		.coluna-desentranhamento
			padding 0 !important

		.label-desentranhamento
			font-weight bold !important
			font-size 0.9em !important
			color #fff !important

			.az-form-content
				height auto

		.text-desentranhamento
			color white !important

		.acao-voltar-desentranhar
			cursor pointer
			background-color #104D75
			color white

		.v-stepper .v-stepper__header .v-divider
			background-color white !important

		.v-stepper__step
			padding 20px 24px 20px 24px !important

		.v-stepper__items
			height 93%

		.v-stepper__step--complete
			.v-icon
				color var(--v-primary-base) !important

			div
				color white !important

		.v-stepper__step--active
			span
				color var(--v-primary-base) !important

			div
				color white !important

	.container-stepper-claro
		.v-stepper__step--active
			div
				color var(--v-primary-base) !important

.v-list-item__icon
	color white !important
@media screen and (min-width: 768px)
	.ata
		.v-tabs-bar
			height getSizeRem(39)
</style>
